import { NgStyle } from '@angular/common';
import { Component, DestroyRef, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { CmsItem } from '@coin/shared/cms/util';
import { IconButtonComponent, V2ButtonComponent } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';
import { v4 as uuid } from 'uuid';
import { SelectMediaComponent } from '../../../dialogs/shared/select-media/select-media.component';

@Component({
  selector: 'coin-gmm-compilation',
  templateUrl: './compilation.component.html',
  styleUrls: ['./compilation.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [V2ButtonComponent, TranslateModule, NgStyle, IconButtonComponent]
})
export class CompilationComponent {
  private dialog = inject(MatDialog);
  private destroyRef = inject(DestroyRef);

  @Input() startanimation = false;
  @Input() item: CmsItem<'compilation'>;
  @Input() contentEdit = false;

  // TO DO: collection is an object and not an array, this code should not work
  public remove(pos: string[], i): void {
    const data = this.item.collection as unknown as unknown[];
    this.iterateObj(pos, data);
    data.splice(i, 1);
  }

  public add(pos: string[]): void {
    const data = this.item.collection as unknown as unknown[];
    this.iterateObj(pos, data);
    data.push({
      img: 'https://media.istockphoto.com/photos/tax-form-with-notepad-pen-pencil-and-calculator-picture-id872852194',
      text: `content.compilation.text-${uuid().split('-')[0]}`
    });
  }

  private iterateObj<T>(pos: string[], array: T[]): T[] {
    let arr = array;
    for (const itm of pos) {
      arr = arr[itm];
    }
    return arr;
  }

  public editPicture(item: CmsItem): void {
    SelectMediaComponent.openDialog(this.dialog, { url: item?.img, mediaType: 'image' })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newImage => {
        if (newImage) {
          item.img = newImage.mediaUrl;
        }
      });
  }
}
